module.exports = __webpack_public_path__ + "static/media/prop-10@2x.30509200.webp";